import { TImage } from '@components/typescript';
import getPublicEnv from '@utils/getPublicEnv';

export const LOG_ERROR = {
  convertToOrder: '[CustomError] Error converting cart to order',
  createPayment: '[CustomError] Error creating payment for order',
  getOrderDetails: '[CustomError] Invalid response when fetching order details',
  PayPalPayment: '[CustomError] Error with PayPal payment',
  PayPalRepayment: '[CustomError] Error with PayPal repayment',
  blurFunction: (image: TImage) => `[CustomError] Image blur does not work ${JSON.stringify(image)}`,
  categoryListingPageProps: '[CustomError] Marketing data with given id is not found',
  AdyenPayment: '[CustomError] Error with Adyen payment',
  productsSiteMap: '[CustomError] Error with Products Sitemap',
  arrangementProductProducts: '[CustomError] Error with products for arrangement product',
};

export const LOG_TYPE = {
  requestToExternalService: 'requestToExternalService',
  blockValidationError: 'blockValidationError',
};

export const CHECKOUT_THANKYOU_PAGE = 'checkout/thankyou';

export const REPAYMENT_THANKYOU_PAGE = 'repayment/[orderId]/thankyou';

export const RESPONSIVE_IMAGE_TYPES = ['mobile', 'tablet', 'desktop'];

export const BLUR_SVG =
  'data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGh' +
  'YaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAEAAIDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAABBQADAAAAAAAAAAAAAAABAAI' +
  'DBAUHEYH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAERElH/2gAMAwEAAhEDEQA/AKJo8f15tCzLLrWXSPlc5znZ2aSSSSSSavZ9REQpY+qw/9k=';

export const PRIVACY_POLICY = '/pages/privacy-policy';

export const LAZY_BOUNDARY = '300px';

export const MAX_SWATCHES_NUMBER = 4;

export const AVAILABLE_REGIONS = {
  poland: 'PL',
  mexico: 'MX',
  euro: 'EUR',
};

// NOTE: from type @ src/typescript/regional.ts
export const AVAILABLE_REGIONS_COUNTRY_CODES = ['MX', 'PL', 'BE', 'DE', 'FR', 'AT'];

export const DEFAULT_LOCALE = process.env.DEFAULT_LOCALE || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE') || 'en';

export const SITE_TYPE_KEY = process.env.SITE_TYPE_KEY || getPublicEnv('NEXT_PUBLIC_SITE_TYPE_KEY') || 'VOX-PL';

export const DEFAULT_IMAGE_QUALITY = 75;

export const SHOWROOMS_SEO_DESCRIPTION_LENGTH = 155;

export const ENVIRONMENT =
  process.env.ENVIRONMENT ||
  getPublicEnv('NEXT_PUBLIC_ENVIRONMENT') ||
  getPublicEnv('NEXT_PUBLIC_SENTRY_ENVIRONMENT') ||
  'prod';

export const DISPLAY_ECO_TAX_INFO =
  process.env.DISPLAY_ECO_TAX_INFO || getPublicEnv('NEXT_PUBLIC_DISPLAY_ECO_TAX_INFO') || 'false';

export const DISPLAY_TRUSTMATE_REVIEWS =
  process.env.DISPLAY_TRUSTMATE_REVIEWS || getPublicEnv('NEXT_PUBLIC_DISPLAY_TRUSTMATE_REVIEWS') || 'false';

export const DISPLAY_DESIGN_STOR =
  process.env.DISPLAY_DESIGN_STOR || getPublicEnv('NEXT_PUBLIC_DISPLAY_DESIGN_STOR') || 'false';

// Konfiguracja sanityzacji HTML dla komponentów WYSIWYG
export const SANITIZE_HTML_CONFIG = {
  allowedTags: ['h2', 'h3', 'h4', 'h5', 'p', 'strong', 'b', 'ul', 'li', 'ol', 'a', 'br', 'span'],
  allowedAttributes: {
    h2: ['class', 'style'],
    h3: ['class', 'style'],
    h4: ['class', 'style'],
    h5: ['class', 'style'],
    p: ['class', 'style'],
    a: ['href', 'target', 'rel'],
    span: ['style', 'background-color'],
  },
};

// Konfiguracja sanityzacji HTML z wymuszeniem otwarcia linków w nowej karcie
export const SANITIZE_HTML_CONFIG_BLANK_TARGET = {
  ...SANITIZE_HTML_CONFIG,
  transformTags: {
    a: (tagName: string, attribs: Record<string, string>) => ({
      tagName,
      attribs: {
        ...attribs,
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    }),
  },
};
